/**
 * this enum is only for channel orders.
 */

export enum PaymentMethodType {
  ApplePay = 'APPLE_PAY',
  Cash = 'CASH',
  CreditCard = 'CREDIT_CARD',
  GiftCart = 'GIFTCARD',
  GooglePay = 'GOOGLE_PAY',
  Paypal = 'PAYPAL',
  Unpaid = 'UNPAID',
}
